import { Button } from 'components';
import styled from 'styled-components';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { CSVLink } from 'react-csv';
import { Link as LinkRouterDom } from 'react-router-dom';

interface IFilterButton {
  background?: string;
  textColor?: string;
  isSelected?: boolean;
}

export const Container = styled.div`
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 24px 32px;
  margin-left: 60px;
  justify-content: start;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 25px 5px;
  width: 100%;
  max-width: 1156px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;

  font-family: 'Montserrat';
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #000000;
`;

export const Link = styled.div`
  font-family: 'Montserrat';
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #000000;
`;

export const ArrowForwardIcon = styled(ArrowForwardIosRoundedIcon)`
  font-size: 18px !important;
`;

export const ArrowBackIcon = styled(ArrowBackIosRoundedIcon)`
  font-size: 16px !important;

  :hover {
    cursor: pointer;
  }
`;

export const BackButton = styled(LinkRouterDom)`
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: center;
  align-items: center;

  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  text-align: left;
  color: #000;
  text-decoration: none;

  :hover {
    cursor: pointer;
    color: #737791;
  }
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  min-width: 940px;
  max-width: 1156px;
  height: 100%;
  padding: 30px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border-radius: 15px;
  border: 1px solid #f8f9fa;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(238, 238, 238, 0.5);
`;

export const FilterButton = styled(Button)<IFilterButton>`
  border-radius: 6px !important;
  height: 100% !important;
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 600 !important;
  text-align: center;
  text-transform: none !important;
  background: ${({ background, isSelected }) => isSelected && background} !important;
  color: ${({ textColor, isSelected }) => isSelected && textColor} !important;
  border-color: ${({ textColor, isSelected }) => isSelected && textColor} !important;
`;

export const FilterButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: -webkit-fill-available;
  width: -moz-available;
`;

export const ContainerFilterButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 20px;
`;

export const ButtonCSV = styled(CSVLink)`
  text-decoration: none;
  display: flex;
`;
